module.exports = __webpack_public_path__ + "img/logo.4ff0dcf7.png";